import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import {
  IconButton,
  MenuItem,
  Tooltip,
  Typography,
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  FormControl,
  Radio,
  RadioGroup,
  FormControlLabel,
  Card,
} from "@mui/material";
import {
  StyledButton,
  StyledInputLabel,
  StyledSelect,
  StyledTextField,
  StyledTableCellHistory,
  StyledTableRowHistory,
  OutlinedIconFab,
  StyledMultilineTextField,
  StyledTableContainer,
} from "../StyledComponents";
import { toast } from "react-toastify";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import MicOffIcon from "@mui/icons-material/MicOff";
import ClearIcon from "@mui/icons-material/Clear";
import Icon from "../Utils/Icons";
import dayjs from "dayjs";
import { durationType } from "../initialData/initialData";
import {
  getHumanReadableDiffInPastDate,
  getHumanReadableDurationInDate,
} from "../Utils/UtilsFunctions";
const FamilyHistory = ({
  familyHistoryData,
  setFamilyHistoryData,
  activeHistorySection,
  setActiveHistorySection,
  startRecording,
  stopRecording,
  isAiEnabled,
}) => {
  console.log("Family History called", familyHistoryData);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [autocompleteData, setAutoCompleteData] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [suggestApiCalled, setSuggestApiCalled] = useState(false);
  const [debounceFunctionCalledCondition, setDebounceFunctionCalledCondition] =
    useState(false);
  const { transcript, resetTranscript } = useSpeechRecognition();
  const [listeningOn, setListeningOn] = useState(false);
  const [familyHistoryVars, setFamilyHistoryVars] = useState({
    relation: "",
    condition: "",
    onSetAge: "",
    deceased: false,
    clinical_note: "",
    onset_duration: "",
    onset_duration_type: "days",
    abatement_duration: "",
    abatement_duration_type: "days",
  });
  const [termSelectedOrAdded, setTermSelectedOrAdded] = useState(false);
  const [conditionName, setConditionName] = useState("");
  const [error, setError] = useState("");
  const [familyHistoryEditIndex, setFamilyHistoryEditIndex] = useState(null);
  const [clinicalNotesListening, setClinicalNotesListening] = useState(false);
  const [mouseDownOnOption, setMouseDownOnOption] = useState(false);

  const debounceTimeout = useRef(null); // Use useRef to persist timeout
  const skipEffect = useRef(false);
  const optionChosen = useRef(false);

  useEffect(() => {
    setAuthToken(sessionStorage.getItem("accessToken"));
  }, [sessionStorage.getItem("accessToken")]);

  useEffect(() => {
    // alert(`DH ${activeHistorySection}`);
    if (activeHistorySection == "Family History") {
      let timerId;

      timerId = setTimeout(() => {
        setConditionName(transcript);
      }, 3000);

      return () => {
        clearTimeout(timerId);
      };
    }
  }, [transcript]);
  useEffect(() => {
    if (skipEffect.current) {
      skipEffect.current = false; // reset after skipping
      return;
    }
    // Call the API with the debounced function when conditionName changes

    let timerOut = setTimeout(() => {
      if (conditionName.trim() !== "") {
        debouncedConditionFilterCall(conditionName.toLowerCase());
      }
    }, 500);
    return () => clearInterval(timerOut);
  }, [conditionName]);

  const startListening = (key) => {
    // alert("MH SL");
    if (transcript) {
      resetTranscript();
    }
    setActiveHistorySection("Family History");
    SpeechRecognition.startListening({ continuous: true, language: "en-IN" });
    setListeningOn(true);
    if (key == "condition") {
      setClinicalNotesListening(false);
    } else {
      setClinicalNotesListening(true);
    }
  };
  const debouncedConditionFilterCall = async (medicine) => {
    console.log("Debounce function called");
    let semanticTagForConditionSearch = "finding++disorder";
    const postBody = {
      term: medicine,
      state: "active",
      semantictag: semanticTagForConditionSearch,
      acceptability: "synonyms",
      returnlimit: "100",
      refsetid: null,
      parentid: null,
      excludeparentconcept: false,
      fullconcept: true,
    };

    try {
      if (conditionName.length > 1) {
        const response = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
          postBody,
          { headers: headers }
        );
        if (response) {
          console.log("Snomed Response", response);
          if (
            response.data.status === "Success" &&
            response.data.data.length > 0
          ) {
            const dataToProcess =
              response.data.data.length > 300
                ? response.data.data.slice(0, 300)
                : response.data.data;

            const filteredData = dataToProcess.map((medicineItem) => {
              return {
                term: medicineItem.term,
                id: medicineItem.conceptId,
              };
            });
            console.log("Filtered Medicine Data", filteredData);
            setAutoCompleteData(filteredData);
            setFilteredOptions(filteredData);
          } else {
            try {
              const response = await axios.post(
                `${REACT_APP_BACKEND_ROUTE_URL}snomed/suggest/`,
                postBody,
                { headers: headers }
              );
              if (response) {
                console.log("Suggest Response", response);
                if (
                  response.data.status === "Success" &&
                  response.data.data.length > 0
                ) {
                  setSuggestApiCalled(true);
                  const dataToProcess =
                    response.data.data.length > 300
                      ? response.data.data.slice(0, 300)
                      : response.data.data;
                  setAutoCompleteData(dataToProcess);
                  setFilteredOptions(dataToProcess);
                  // setSelectedFromSuggestion(true);
                } else {
                  // setSelectedFromSuggestion(true);

                  setAutoCompleteData([]);
                  setFilteredOptions([]);
                }
              }
            } catch (err) {
              console.log(err);
              toast.error(err);
            }
          }
          setDebounceFunctionCalledCondition(true);
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  };
  const handleAddRow = async () => {
    if (familyHistoryVars.condition || conditionName.length > 0) {
      // Store the updated state in a local variable
      let newDetails,
        updatedFound = {},
        updatedSelectedOptiondetsils = {},
        foundData = false;

      if (!optionChosen.current) {
        const postBody = {
          term: conditionName,
          state: "active",
          semantictag: "finding++disorder",
          acceptability: "synonyms",
          returnlimit: "100",
          refsetid: null,
          parentid: null,
          excludeparentconcept: false,
          fullconcept: true,
        };

        try {
          if (conditionName.length > 1) {
            const response = await axios.post(
              `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
              postBody,
              { headers: headers }
            );
            if (response) {
              console.log("Snomed Response", response);
              if (
                response.data.status === "Success" &&
                response.data.data.length > 0
              ) {
                foundData = response.data.data.find(
                  (d) => d.term === conditionName
                );
                console.log("Found Data", foundData);
                if (foundData) {
                  updatedFound = {
                    ...foundData,
                    found: true,
                    id: foundData.conceptId,
                  };
                } else {
                  updatedSelectedOptiondetsils = {
                    hierarchy: null,
                    isPreferredTerm: null,
                    conceptState: null,
                    conceptFsn: conditionName,
                    definitionStatus: null,
                    conceptId: null,
                    languageCode: "en",
                    typeId: null,
                    term: conditionName,
                    caseSignificanceId: "CASE_INSENSITIVE",
                    id: null,
                    effectiveTime: null,
                    activeStatus: null,
                    moduleId: null,
                  };
                }
              } else {
                updatedSelectedOptiondetsils = {
                  hierarchy: null,
                  isPreferredTerm: null,
                  conceptState: null,
                  conceptFsn: conditionName,
                  definitionStatus: null,
                  conceptId: null,
                  languageCode: "en",
                  typeId: null,
                  term: conditionName,
                  caseSignificanceId: "CASE_INSENSITIVE",
                  id: null,
                  effectiveTime: null,
                  activeStatus: null,
                  moduleId: null,
                };
              }

              if (foundData) {
                console.log("updatedFound", updatedFound);
                newDetails = {
                  ...familyHistoryVars,
                  condition: updatedFound.term,
                  id: updatedFound.id,
                };
              } else {
                console.log(
                  "updatedSelectedOptiondetsils",
                  updatedSelectedOptiondetsils
                );
                newDetails = {
                  ...familyHistoryVars,
                  condition: updatedSelectedOptiondetsils.term,
                  id: updatedSelectedOptiondetsils.id,
                };
              }
            } else {
              newDetails = {
                ...familyHistoryVars,
                condition: conditionName,
                id: null,
              };
            }
          }
        } catch (err) {
          console.log(err);
          // toast.error(err);
          newDetails = {
            ...familyHistoryVars,
            condition: conditionName,
            id: null,
          };
        }
      } else {
        newDetails = { ...familyHistoryVars };
      }

      const newRow = {
        relation: newDetails.relation,
        condition: newDetails.condition,
        onSetAge: newDetails.onSetAge,
        deceased: newDetails.deceased,
        clinical_note: newDetails?.clinical_note,
        onset_duration: newDetails?.onset_duration,
        onset_duration_type: newDetails?.onset_duration_type,
        abatement_duration: newDetails?.abatement_duration,
        abatement_duration_type: newDetails?.abatement_duration_type,
        onset_datetime: newDetails?.onset_datetime?.format("YYYY-MM-DD"),       // ADD
        abatement_datetime: newDetails?.abatement_datetime?.format("YYYY-MM-DD"),
      };

      // Update family history rows by adding the new row

      const updatedRows = [...familyHistoryData["new"], newRow];

      setFamilyHistoryData({
        ...familyHistoryData,
        new: updatedRows,
      });
      // Reset family history variables and clear error
      setFamilyHistoryVars({
        ...familyHistoryVars,
        relation: "",
        condition: "",
        onSetAge: "",
        clinical_note: "",
        deceased: false,
        onset_duration: "",
        onset_duration_type: "days",
        abatement_duration: "",
        abatement_duration_type: "days",
      });
      setConditionName("");
      setError("");
      setDebounceFunctionCalledCondition(false);
      setTermSelectedOrAdded(false);
      optionChosen.current = false;
      setFilteredOptions([]);
    } else {
      // Set error message if any field is missing
      setError("Condition Name field is required");
    }
  };
  const handleFamilyHistoryEditClick = (row, rowIndex) => {
    setConditionName(row.condition);
    setFamilyHistoryVars({
      relation: row.relation,
      onSetAge: row.onSetAge,
      deceased: row.deceased,
      clinical_note: row?.clinical_note,
      condition: "",
      onset_duration: row?.onset_duration,
      onset_duration_type: row?.onset_duration_type || "days",
      abatement_duration: row?.abatement_duration,
      abatement_duration_type: row?.abatement_duration_type || "days",
      onset_datetime: row?.onset_datetime ? dayjs(row.onset_datetime) : null,
      abatement_datetime: row?.abatement_datetime ? dayjs(row.abatement_datetime) : null,
    });
    setFamilyHistoryEditIndex(rowIndex);
  };
  const handleFamilyHistoryUpdate = async () => {
    if (familyHistoryVars.condition || conditionName.length > 0) {
      // Store the updated state in a local variable

      let newDetails,
        updatedFound = {},
        updatedSelectedOptiondetsils = {},
        foundData = false;

      if (!optionChosen.current) {
        const postBody = {
          term: conditionName,
          state: "active",
          semantictag: "finding++disorder",
          acceptability: "synonyms",
          returnlimit: "100",
          refsetid: null,
          parentid: null,
          excludeparentconcept: false,
          fullconcept: true,
        };

        try {
          if (conditionName.length > 1) {
            const response = await axios.post(
              `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
              postBody,
              { headers: headers }
            );
            if (response) {
              console.log("Snomed Response", response);
              if (
                response.data.status === "Success" &&
                response.data.data.length > 0
              ) {
                foundData = response.data.data.find(
                  (d) => d.term === conditionName
                );
                console.log("Found Data", foundData);
                if (foundData) {
                  updatedFound = {
                    ...foundData,
                    found: true,
                    id: foundData.conceptId,
                  };
                } else {
                  updatedSelectedOptiondetsils = {
                    hierarchy: null,
                    isPreferredTerm: null,
                    conceptState: null,
                    conceptFsn: conditionName,
                    definitionStatus: null,
                    conceptId: null,
                    languageCode: "en",
                    typeId: null,
                    term: conditionName,
                    caseSignificanceId: "CASE_INSENSITIVE",
                    id: null,
                    effectiveTime: null,
                    activeStatus: null,
                    moduleId: null,
                  };
                }
              } else {
                updatedSelectedOptiondetsils = {
                  hierarchy: null,
                  isPreferredTerm: null,
                  conceptState: null,
                  conceptFsn: conditionName,
                  definitionStatus: null,
                  conceptId: null,
                  languageCode: "en",
                  typeId: null,
                  term: conditionName,
                  caseSignificanceId: "CASE_INSENSITIVE",
                  id: null,
                  effectiveTime: null,
                  activeStatus: null,
                  moduleId: null,
                };
              }

              if (foundData) {
                console.log("updatedFound", updatedFound);
                newDetails = {
                  ...familyHistoryVars,
                  condition: updatedFound.term,
                  id: updatedFound.id,
                };
              } else {
                console.log(
                  "updatedSelectedOptiondetsils",
                  updatedSelectedOptiondetsils
                );
                newDetails = {
                  ...familyHistoryVars,
                  condition: updatedSelectedOptiondetsils.term,
                  id: updatedSelectedOptiondetsils.id,
                };
              }
            } else {
              newDetails = {
                ...familyHistoryVars,
                condition: conditionName,
                id: null,
              };
            }
          }
        } catch (err) {
          console.log(err);
          // toast.error(err);
          newDetails = {
            ...familyHistoryVars,
            condition: conditionName,
            id: null,
          };
        }
      } else {
        newDetails = { ...familyHistoryVars };
      }

      const updatedRow = {
        relation: newDetails.relation,
        condition: newDetails.condition,
        onSetAge: newDetails.onSetAge,
        deceased: newDetails.deceased,
        clinical_note: newDetails?.clinical_note,
        onset_duration: newDetails?.onset_duration,
        onset_duration_type: newDetails?.onset_duration_type,
        abatement_duration: newDetails?.abatement_duration,
        abatement_duration_type: newDetails?.abatement_duration_type,
        onset_datetime: newDetails?.onset_datetime?.format("YYYY-MM-DD"),       // ADD
        abatement_datetime: newDetails?.abatement_datetime?.format("YYYY-MM-DD"),
        source: undefined,
      };

      // Update family history rows by adding the new row

      const updatedFamilyHistory = familyHistoryData["new"].map(
        (row, index) => {
          if (index === familyHistoryEditIndex) {
            return updatedRow;
          } else {
            return row;
          }
        }
      );
      setFamilyHistoryData({
        ...familyHistoryData,
        new: updatedFamilyHistory,
      });
      // Reset family history variables and clear error
      setFamilyHistoryVars({
        ...familyHistoryVars,
        relation: "",
        condition: "",
        onSetAge: "",
        clinical_note: "",
        deceased: false,
        onset_duration: "",
        onset_duration_type: "days",
        abatement_duration: "",
        abatement_duration_type: "days",
      });
      setFamilyHistoryEditIndex(null);
      setError("");
      setConditionName("");
      setDebounceFunctionCalledCondition(false);
      setTermSelectedOrAdded(false);
      setFilteredOptions([]);
      optionChosen.current = false;
    } else {
      // Set error message if any field is missing
      setError("Condition Name field is required");
    }
  };
  const handleFamilyHistoryDelete = (rowIndex) => {
    // Filter out the row at the specified index
    const updatedFamilyHistory = familyHistoryData["new"].filter(
      (row, index) => index !== rowIndex
    );
    // Update the state with the filtered array
    setFamilyHistoryData({
      ...familyHistoryData,
      new: updatedFamilyHistory,
    });
  };
  const calculateOnsetDate = (duration, type) => {
    if (duration === null || duration === undefined || isNaN(parseInt(duration))) return null;
    const today = dayjs();
    const durationMap = {
      minutes: "minute",
      hours: "hour",
      days: "day",
      weeks: "week",
      months: "month",
      years: "year",
    };
    return today.subtract(duration, durationMap[type]);
  };
  const calculateAbatementDate = (onset_datetime, duration, type) => {
    if (duration === null || duration === undefined || isNaN(parseInt(duration)) || !onset_datetime) return null;
    const durationMap = {
      minutes: "minute",
      hours: "hour",
      days: "day",
      weeks: "week",
      months: "month",
      years: "year",
    };
    return dayjs(onset_datetime).add(duration, durationMap[type]);
  };

  const handleChangeFamilyHistory = (field, value) => {
    if (field == "condition") {
      setAutoCompleteData([]);
      setFilteredOptions([]);
      setTermSelectedOrAdded(true);
    }

    let newDetails = {
      ...familyHistoryVars,
      [field]: field == "condition" ? value : value,
    };

    if (
      (field === "onset_duration" || field === "onset_duration_type") &&
      newDetails.onset_duration &&
      newDetails.onset_duration_type
    ) {
      const calculatedDate = calculateOnsetDate(
        parseInt(newDetails.onset_duration),
        newDetails.onset_duration_type
      );
      newDetails.onset_datetime = calculatedDate ?? null;
    } else if (field === "onset_duration" || field === "onset_duration_type") {
      newDetails.onset_datetime = null;
    }

    if (
      (field === "abatement_duration" || field === "abatement_duration_type") &&
      newDetails.abatement_duration &&
      newDetails.abatement_duration_type
    ) {
      const calculatedDate = calculateAbatementDate(
        newDetails.onset_datetime,
        parseInt(newDetails.abatement_duration),
        newDetails.abatement_duration_type
      );
      newDetails.abatement_datetime = calculatedDate ?? null;
    } else if (
      field === "abatement_duration" ||
      field === "abatement_duration_type"
    ) {
      newDetails.abatement_datetime = null;
    }

    setFamilyHistoryVars(newDetails);
  };
  const handleClearConditionName = () => {
    setError("");
    setConditionName("");
    resetTranscript();
    setFamilyHistoryVars({
      ...familyHistoryVars,
      condition: "", // Use computed property name to set the field dynamically
    });
    setTermSelectedOrAdded(false);
    setFilteredOptions([]);
    setDebounceFunctionCalledCondition(false);
    // setMedicineList([])
  };
  const handleAddOption = async (term) => {
    const postBody = {
      term: term,
      state: "active",
      semantictag: "finding++disorder",
      acceptability: "synonyms",
      returnlimit: "100",
      refsetid: null,
      parentid: null,
      excludeparentconcept: false,
      fullconcept: true,
    };

    try {
      if (conditionName.length > 1) {
        const response = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
          postBody,
          { headers: headers }
        );
        if (response) {
          let updatedFound = {},
            updatedSelectedOptiondetsils = {},
            foundData = false;
          console.log("Snomed Response", response);
          if (
            response.data.status === "Success" &&
            response.data.data.length > 0
          ) {
            foundData = response.data.data.find((d) => d.term === term);
            console.log("Found Data", foundData);
            if (foundData) {
              updatedFound = {
                ...foundData,
                found: true,
                id: foundData.conceptId,
              };
            } else {
              updatedSelectedOptiondetsils = {
                hierarchy: null,
                isPreferredTerm: null,
                conceptState: null,
                conceptFsn: term,
                definitionStatus: null,
                conceptId: null,
                languageCode: "en",
                typeId: null,
                term: term,
                caseSignificanceId: "CASE_INSENSITIVE",
                id: null,
                effectiveTime: null,
                activeStatus: null,
                moduleId: null,
              };
            }
          } else {
            updatedSelectedOptiondetsils = {
              hierarchy: null,
              isPreferredTerm: null,
              conceptState: null,
              conceptFsn: term,
              definitionStatus: null,
              conceptId: null,
              languageCode: "en",
              typeId: null,
              term: term,
              caseSignificanceId: "CASE_INSENSITIVE",
              id: null,
              effectiveTime: null,
              activeStatus: null,
              moduleId: null,
            };
          }

          setAutoCompleteData([]);
          setFilteredOptions([]);
          setSuggestApiCalled(false);
          setDebounceFunctionCalledCondition(true);
          if (foundData) {
            handleChangeFamilyHistory("condition", updatedFound.term);
          } else {
            handleChangeFamilyHistory(
              "condition",
              updatedSelectedOptiondetsils.term
            );
          }
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  };
  const handleClearClinicalNotes = () => {
    setError("");

    resetTranscript();
    setFamilyHistoryVars({
      ...familyHistoryVars,
      clinical_note: "", // Use computed property name to set the field dynamically
    });
  };
  const handleConditionTyped = (value) => {
    setConditionName(value);

    // if (debounceTimeout.current) {
    //   clearTimeout(debounceTimeout.current); // Clear previous timeout
    // }

    // debounceTimeout.current = setTimeout(() => {
    //   handleAddOption(value); // Only triggers after user stops typing
    // }, 500); // Adjust delay as needed
  };

  return (
    <Card
      sx={{
        borderRadius: "10px",
        boxShadow: "0 4px 4px 0 #C7C7CC inset",
        backgroundColor: "#FFF",
      }}
    >
      <Grid
        container
        spacing={2}
        sx={{ margin: "5px 0px", display: "flex", alignItems: "center" }}
      >
        <Grid item xs={11} sm={11} sx={{ margin: "5px 0px" }}>
          <StyledTextField
            fullWidth
            label="Condition"
            value={
              // familyHistoryVars.condition !== ""
              //   ? familyHistoryVars.condition
              //   :
              conditionName
            }
            onChange={(e) => {
              // if (!familyHistoryVars.condition) {
              //   setConditionName(e.target.value);
              // }
              handleConditionTyped(e.target.value);
            }}
            onBlur={() => {
              setTimeout(() => {
                const shouldClear = !mouseDownOnOption;

                if (shouldClear) {
                  // setIsFocused(false);
                  setFilteredOptions([]);
                  setDebounceFunctionCalledCondition(false);
                  setTermSelectedOrAdded(false);
                }

                setMouseDownOnOption(false);
              }, 100);
            }}
            onFocus={() => {
              // setIsFocused(true);
              if (conditionName.trim() !== "") {
                debouncedConditionFilterCall(conditionName.toLowerCase()); // re-trigger filtering
              }
            }}
            InputProps={{
              endAdornment: (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ marginRight: "5px" }}>
                    <Tooltip title="Clear">
                      <OutlinedIconFab
                        size="small"
                        variant="contained"
                        onClick={handleClearConditionName}
                      >
                        <Icon name="clearTextField" size={32} />
                      </OutlinedIconFab>
                    </Tooltip>
                  </div>
                  {/* {!termSelectedOrAdded && (
                    <Tooltip title="Add" style={{ marginRight: "5px" }}>
                      <OutlinedIconFab
                        size="small"
                        variant="contained"
                        onClick={handleAddOption}
                      >
                        <AddIcon />
                      </OutlinedIconFab>
                    </Tooltip>
                  )} */}
                  <>
                    {isAiEnabled &&
                      (listeningOn === false ? (
                        <Tooltip title="Start Listening">
                          <OutlinedIconFab
                            // onClick={() => startListening("condition")}
                            onClick={() => {
                              startRecording();
                              setListeningOn(true);
                            }}
                            variant="contained"
                            color="defaultColor"
                            size="small"
                          >
                            <Icon name="micNotInUse" size={32} />
                          </OutlinedIconFab>
                        </Tooltip>
                      ) : listeningOn === true &&
                        clinicalNotesListening === true ? (
                        <Tooltip title="Start Listening">
                          <OutlinedIconFab
                            // onClick={() => startListening("condition")}
                            onClick={() => {
                              startRecording();
                              setListeningOn(true);
                            }}
                            variant="contained"
                            color="default"
                            size="small"
                          >
                            <Icon name="micNotInUse" size={32} />
                          </OutlinedIconFab>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Stop Listening">
                          <OutlinedIconFab
                            onClick={() => {
                              // SpeechRecognition.stopListening();
                              stopRecording("Family History");
                              setListeningOn(false);
                            }}
                            variant="outlined"
                            color="default"
                            size="small"
                          >
                            <Icon name="micInUse" size={32} />
                          </OutlinedIconFab>
                        </Tooltip>
                      ))}
                  </>
                </div>
              ),
            }}
          />
          {filteredOptions.length > 0 ? (
            <div
              style={{
                backgroundColor: "#f5f5f5",
                borderRadius: "10px",
                padding: "20px",
                maxHeight: "200px", // Set your desired maximum height here
                overflowY: "auto", // Add vertical scrolling
              }}
            >
              {/* Display filtered medicines */}
              {suggestApiCalled && (
                <div style={{ color: "red" }}>
                  No Exact Matches found ! You can search for the following
                  Suggestions.
                </div>
              )}

              <>
                {filteredOptions.map((op) => (
                  <div key={op}>
                    {
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {op.added ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <StyledButton
                              color="success"
                              sx={{
                                textAlign: "left",
                                justifyContent: "flex-start",
                                width: "100%",
                              }}
                            >
                              {op.term}
                            </StyledButton>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                flexDirection: "row",
                                color: "green",
                                fontStyle: "bold",
                              }}
                            >
                              <span>&#10003;</span>
                              <span>(Added)</span>
                            </div>
                          </div>
                        ) : (
                          <StyledButton
                            color="grey"
                            sx={{
                              textAlign: "left",
                              justifyContent: "flex-start",
                              width: "100%",
                            }}
                            onClick={() => {
                              skipEffect.current = true; // prevent debounce call
                              optionChosen.current = true;
                              setConditionName(op.term);
                              handleChangeFamilyHistory("condition", op.term);
                            }}
                            onMouseDown={() => setMouseDownOnOption(true)}
                          >
                            {op.term}
                          </StyledButton>
                        )}
                      </div>
                    }
                  </div>
                ))}
              </>
            </div>
          ) : filteredOptions.length == 0 &&
            debounceFunctionCalledCondition &&
            !termSelectedOrAdded ? (
            <div
              style={{
                backgroundColor: "#f5f5f5",
                borderRadius: "10px",
                padding: "20px",
                maxHeight: "300px", // Set your desired maximum height here
                overflowY: "auto", // Add vertical scrolling
              }}
            >
              <div style={{ color: "red" }}>No Options Found!</div>
            </div>
          ) : null}
        </Grid>
        <Grid item xs={11} md={11} sm={11}>
          <StyledTextField
            // id="outlined-multiline-static"
            variant="outlined"
            label="Clinical Notes"
            // multiline
            // rows={2}
            value={familyHistoryVars.clinical_note}
            onChange={(e) =>
              handleChangeFamilyHistory("clinical_note", e.target.value)
            }
            fullWidth
            InputProps={{
              endAdornment: (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ marginRight: "5px" }}>
                    <Tooltip title="Clear">
                      <OutlinedIconFab
                        size="small"
                        variant="contained"
                        onClick={handleClearClinicalNotes}
                      >
                        <Icon name="clearTextField" size={32} />
                      </OutlinedIconFab>
                    </Tooltip>
                  </div>

                  <>
                    {/* {listeningOn === false ? (
                      <Tooltip title="Start Listening">
                        <OutlinedIconFab
                          onClick={() => startListening("clinical_note")}
                          variant="contained"
                          color="defaultColor"
                          size="small"
                        >
                          <MicOffIcon />
                        </OutlinedIconFab>
                      </Tooltip>
                    ) : listeningOn === true &&
                      clinicalNotesListening === false ? (
                      <Tooltip title="Start Listening">
                        <OutlinedIconFab
                          onClick={() => startListening("clinical_note")}
                          variant="contained"
                          color="default"
                          size="small"
                        >
                          <MicOffIcon />
                        </OutlinedIconFab>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Stop Listening">
                        <OutlinedIconFab
                          onClick={() => {
                            SpeechRecognition.stopListening();
                            setListeningOn(false);
                            setClinicalNotesListening(false);
                          }}
                          variant="outlined"
                          color="default"
                          size="small"
                        >
                          <KeyboardVoiceIcon />
                        </OutlinedIconFab>
                      </Tooltip>
                    )} */}
                  </>
                </div>
              ),
            }}
          />
        </Grid>
        <Grid item xs={11} sm={5} sx={{ margin: "5px 0px", display: "flex", alignItems: "center" }}>
          <FormControl fullWidth>
            <StyledInputLabel>Select Relation</StyledInputLabel>
            <StyledSelect
              value={familyHistoryVars.relation}
              onChange={(e) =>
                handleChangeFamilyHistory("relation", e.target.value)
              }
              label="Select Relation"
            >
              {[
                "Father",
                "Mother",
                "Wife",
                "Husband",
                "Son",
                "Daughter",
                "Sister",
                "Brother",
                "Grandfather",
                "Grandmother",
                "Uncle",
                "Aunt",
                "Parents",
                "Siblings",
              ].map((relation) => (
                <MenuItem
                  key={relation}
                  value={relation}
                  sx={{ fontSize: "12px" }}
                >
                  {relation}
                </MenuItem>
              ))}
            </StyledSelect>
          </FormControl>
        </Grid>

        <Grid item xs={8} sm={3} md={2} sx={{ margin: "5px 0px", display: "flex", alignItems: "center" }}>
          <StyledTextField
            fullWidth
            label="On Set Age"
            type="number"
            value={familyHistoryVars.onSetAge ?? ""}
            onChange={(e) => {
              const value = e.target.value;
              handleChangeFamilyHistory(
                "onSetAge",
                value === "" ? "" : parseInt(value, 10)
              );
            }}
          />
        </Grid>

        <Grid
          item
          xs={6}
          sm={6}
          md={5}
          sx={{
            margin: "5px 0px",
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          <FormControl
            component="fieldset"
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Typography
              variant="body1"
              sx={{ marginRight: "10px" }}
              color={"grey"}
            >
              Deceased:
            </Typography>
            <RadioGroup
              row
              aria-label="deceased"
              name="deceased"
              value={familyHistoryVars.deceased === "N/A" ? "N/A" : (familyHistoryVars.deceased ? "Yes" : "No")}
              onChange={(e) => {
                if (e.target.value === "Yes") {
                  handleChangeFamilyHistory("deceased", true);
                } else if (e.target.value === "No") {
                  handleChangeFamilyHistory("deceased", false);
                } else {
                  handleChangeFamilyHistory("deceased", "N/A");
                }
              }}
            >
              <FormControlLabel
                value="Yes"
                control={
                  <Radio
                    sx={{
                      color: "#21cdc0",
                      "&.Mui-checked": {
                        color: "#21cdc0",
                      },
                    }}
                  />
                }
                label="Yes"
              />
              <FormControlLabel
                value="No"
                control={
                  <Radio
                    sx={{
                      color: "#21cdc0",
                      "&.Mui-checked": {
                        color: "#21cdc0",
                      },
                    }}
                  />
                }
                label="No"
              />
              <FormControlLabel
                value="N/A"
                control={
                  <Radio
                    sx={{
                      color: "#21cdc0",
                      "&.Mui-checked": {
                        color: "#21cdc0",
                      },
                    }}
                  />
                }
                label="N/A"
              />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Row 4: condition onset + duration */}
        <Grid container item xs={12} spacing={1} alignItems="center">
          <Grid item xs={12} sm={6} md={2} style={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="How long ago the condition started">
              <Typography variant="body2" sx={{ mr: 1 }}>
                Condition Onset:
              </Typography>
            </Tooltip>
            <StyledTextField
              type="number"
              label="Duration"
              variant="outlined"
              value={familyHistoryVars.onset_duration}
              onChange={(e) =>
                handleChangeFamilyHistory("onset_duration", e.target.value)
              }
              fullWidth
              onWheel={(e) => e.target.blur()}
              InputProps={{
                inputProps: { style: { MozAppearance: "textfield" } },
                sx: {
                  "& input[type=number]": { MozAppearance: "textfield" },
                  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                },
              }}
            />
          </Grid>

          <Grid item xs={6} sm={5} md={2.5}>
            <StyledTextField
              select
              value={familyHistoryVars.onset_duration_type}
              onChange={(e) =>
                handleChangeFamilyHistory("onset_duration_type", e.target.value)
              }
              fullWidth
              label="Duration Type"
            >
              {durationType.map((type) => (
                <MenuItem key={type.value} value={type.value} sx={{ fontSize: "12px" }}>
                  {type.display}
                </MenuItem>
              ))}
            </StyledTextField>
          </Grid>

          <Grid item xs={12} sm={6} md={2} style={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="How long the condition has been present">
              <Typography variant="body2" sx={{ mr: 1 }}>
                Condition Duration:
              </Typography>
            </Tooltip>
            <StyledTextField
              label="Duration"
              fullWidth
              type="number"
              value={familyHistoryVars.abatement_duration || ""}
              onChange={(e) =>
                handleChangeFamilyHistory("abatement_duration", e.target.value)
              }
              onWheel={(e) => e.target.blur()}
              InputProps={{
                inputProps: { style: { MozAppearance: "textfield" } },
                sx: {
                  "& input[type=number]": { MozAppearance: "textfield" },
                  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                },
              }}
            />
          </Grid>
          <Grid item xs={6} sm={5} md={2.5}>
            <StyledTextField
              select
              fullWidth
              label="Duration Type"
              value={familyHistoryVars.abatement_duration_type || "days"}
              onChange={(e) =>
                handleChangeFamilyHistory("abatement_duration_type", e.target.value)
              }
            >
              {durationType.map((type) => (
                <MenuItem key={type.value} value={type.value} sx={{ fontSize: "12px" }}>
                  {type.display}
                </MenuItem>
              ))}
            </StyledTextField>
          </Grid>

          <Grid item xs={12} sm={2} md={2}>
            <StyledButton
              bgColor="#0E3F66"
              variant="contained"
              fullWidth
              onClick={
                familyHistoryEditIndex !== null
                  ? handleFamilyHistoryUpdate
                  : handleAddRow
              }
              color="defaultColor"
            >
              {familyHistoryEditIndex !== null ? "Update" : "Add"}
            </StyledButton>
          </Grid>
        </Grid>

        {error && <Typography style={{ color: "red" }}>{error}</Typography>}

        <Grid item xs={11} sm={11}>
          {familyHistoryData["prev"].length > 0 && (
            <StyledTableContainer
              component={Paper}
            // sx={{
            //   marginTop: "20px",
            //   border: "1px solid #21cdc0",
            // }}
            >
              <Table>
                <TableHead>
                  <StyledTableRowHistory>
                    <StyledTableCellHistory>Relation</StyledTableCellHistory>
                    <StyledTableCellHistory>Condition</StyledTableCellHistory>
                    <StyledTableCellHistory>On Set Age</StyledTableCellHistory>
                    <StyledTableCellHistory>Deceased</StyledTableCellHistory>
                    <StyledTableCellHistory>
                      Clinical Notes
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>Condition Onset</StyledTableCellHistory>
                    <StyledTableCellHistory>Condition Duration</StyledTableCellHistory>
                    <StyledTableCellHistory>Action</StyledTableCellHistory>
                  </StyledTableRowHistory>
                </TableHead>
                <TableBody>
                  {familyHistoryData["prev"].map((row, rowIndex) => (
                    <StyledTableRowHistory key={rowIndex}>
                      <StyledTableCellHistory>
                        {row?.relation || "-"}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {row?.condition || "-"}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {row?.onSetAge || "-"}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {row?.deceased === "N/A" ? "N/A" : (row?.deceased ? "Yes" : "No")}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {row?.clinical_note ? row.clinical_note : "-"}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {row?.onset_datetime
                          ? `${getHumanReadableDiffInPastDate(row?.onset_datetime)} ago`
                          : (row?.onset_duration ? `${row?.onset_duration} ${row?.onset_duration_type} ago` : "-")}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {row?.abatement_datetime
                          ? getHumanReadableDurationInDate(row?.onset_datetime, row?.abatement_datetime)
                          : (row?.abatement_duration ? `${row?.abatement_duration} ${row?.abatement_duration_type}` : "-")}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>-</StyledTableCellHistory>
                    </StyledTableRowHistory>
                  ))}
                </TableBody>
              </Table>
            </StyledTableContainer>
          )}
        </Grid>
        <Grid item xs={11} sm={11}>
          {familyHistoryData["new"].length > 0 && (
            <StyledTableContainer
              component={Paper}
            // sx={{
            //   margin: "5px 2px",
            //   border: "1px solid #21cdc0",
            // }}
            >
              <Table>
                <TableHead>
                  <StyledTableRowHistory>
                    <StyledTableCellHistory>Relation</StyledTableCellHistory>
                    <StyledTableCellHistory>Condition</StyledTableCellHistory>
                    <StyledTableCellHistory>On Set Age</StyledTableCellHistory>
                    <StyledTableCellHistory>Deceased</StyledTableCellHistory>
                    <StyledTableCellHistory>
                      Clinical Notes
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>Condition Onset</StyledTableCellHistory>
                    <StyledTableCellHistory>Condition Duration</StyledTableCellHistory>
                    <StyledTableCellHistory>Action</StyledTableCellHistory>
                  </StyledTableRowHistory>
                </TableHead>
                <TableBody>
                  {familyHistoryData["new"].map((row, rowIndex) => (
                    <StyledTableRowHistory key={rowIndex}>
                      {/* {console.log("Family History row", row)} */}
                      <StyledTableCellHistory>
                        {row?.relation || "-"}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {row?.condition}
                        {row?.source === "voice" && !row.id && (
                          <Tooltip title="Machine-interpreted text — please verify before confirming">
                            <span className="missing-id-warning">⚠️</span>
                          </Tooltip>
                        )}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {isNaN(row?.onSetAge)
                          ? "-"
                          : row?.onSetAge
                          ? row?.onSetAge
                          : "-"}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {row?.deceased === "N/A" ? "N/A" : (row?.deceased ? "Yes" : "No")}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {row.clinical_note ? row.clinical_note : "-"}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {row?.onset_duration ? `${row?.onset_duration} ${row?.onset_duration_type} ago` : "-"}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {row?.abatement_duration ? `${row?.abatement_duration} ${row?.abatement_duration_type}` : "-"}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {familyHistoryData["prev"].includes(row) ? (
                          "-"
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <Tooltip title="Edit">
                              <OutlinedIconFab
                                onClick={() =>
                                  handleFamilyHistoryEditClick(row, rowIndex)
                                }
                                sx={{ marginRight: 1 }}
                              >
                                <Icon name="editInTable" size={32} />
                              </OutlinedIconFab>
                            </Tooltip>
                            <Tooltip title="Delete">
                              <OutlinedIconFab
                                onClick={() =>
                                  handleFamilyHistoryDelete(rowIndex)
                                }
                              >
                                <Icon name="deleteInTable" size={32} />
                              </OutlinedIconFab>
                            </Tooltip>
                          </div>
                        )}
                      </StyledTableCellHistory>
                    </StyledTableRowHistory>
                  ))}
                </TableBody>
              </Table>
            </StyledTableContainer>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};

export default FamilyHistory;
